import i18n from "i18next";

export const getShortNameFromId = (event: number, idOnly = false) => {
  const prefix = idOnly ? "" : i18n.t("events.shortName", "RD");
  return `${prefix}${event}`;
};

export const getEventShortName = (eventName: string) =>
  eventName.match(/\d+/g)?.join(".");

export const getIdFromEventName = (eventName: string) =>
  Number(getEventShortName(eventName));

// Handles temporary change in round numbering between R10-R23
// Currently not in use, but kept for potential future round number adjustments
export const getDisplayRoundNumber = (eventId: number) => {
  return eventId;
};
